import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Col, Row, Table } from 'react-bootstrap';
import * as CONST from '../../../includes/Constant';
import { S_FORMAT_INR_CURRENCY_AND_AMOUNT, SD_FY_MONTHS, SD_GET_YEAR_DATA, S_CURRENT_FINACIAL_MONTH } from '../../../includes/staticData';
import Select from 'react-select';
import useAuthInfo from '../../../../hooks/IsAdmin';
import { toast } from 'react-toastify';

export default function DashBoradTopPayingVendors() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(null);
  const [financialYears, setFinancialYears] = useState([]);
  const { isAdmin, eDepartmentId } = useAuthInfo();
  const { YEAR_LIST, CURRENT_FINANCIAL_YEAR, SELECTED_YEAR } = SD_GET_YEAR_DATA();
  const [departmentList, setDepartmentList] = useState([]);
  const [departments, setDepartments] = useState(null);
  const [searchParams, setSearchParams] = useState({});
  const [currentFinancialYears, setCurrentFinancialYears] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);

  useEffect(() => {
    if (YEAR_LIST) { setFinancialYears(YEAR_LIST); }
    if (CURRENT_FINANCIAL_YEAR) { setCurrentFinancialYears(CURRENT_FINANCIAL_YEAR); }
    if (SELECTED_YEAR) { setSelectedYear(SELECTED_YEAR); }
    if (isAdmin) { fetchDepartmentList(); }
    setSelectedMonth(S_CURRENT_FINACIAL_MONTH());
    const defaultParams = {
      year: CURRENT_FINANCIAL_YEAR,
      department_id: isAdmin ? "" : eDepartmentId,
      month: S_CURRENT_FINACIAL_MONTH().value || "",
    };
    setSearchParams(defaultParams);
    fetchData(defaultParams);
  }, []);

  const fetchDepartmentList = async () => {
    try {
      const departmentResponse = await axios.get(CONST.GET_DEPARTMENT_LIST);
      if (departmentResponse.data.status === 'success') {
        setDepartmentList(departmentResponse.data.data.map(dept => ({ value: dept.id, label: dept.name })));
      }
    } catch (error) {
      toast.error('Error:', error);
    }
  };
  const fetchData = async (param) => {
    try {
      setLoading(true);
      const response = await axios.get(CONST.DASH_TOP_PAYING_VENDORS, {
        params: {
          year: param.year,
          department_id: param?.department_id || "",
          month: param?.month || "",
        }
      });
      setData(response.data.data || []);
    } catch (error) {
      console.error('Error fetching financial summary:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);
  };
  const handleDepartmentChange = (selectedOption) => {
    setDepartments(selectedOption);
  };

  const handleSearch = () => {

    const newParams = {
      year: selectedYear ? selectedYear.value : "",
      department_id: isAdmin ? departments?.value : eDepartmentId,
      month: selectedMonth ? selectedMonth.value : "",
    };
    setSearchParams(newParams);
    fetchData(newParams);
  };
  const handleReset = () => {
    const newParams = {
      year: CURRENT_FINANCIAL_YEAR ?? "",
      department_id: isAdmin ? "" : eDepartmentId,
      month: "",
    };
    setDepartments("");
    setSelectedYear(SELECTED_YEAR);
    setSearchParams(newParams);
    fetchData(newParams);
  }
  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
  };
  const handleExport = async () => {
    setLoading(true);
    try {
      const response = await axios.post(CONST.EXPORT_TOP_PAYING_VENDORS, {
        year: searchParams.year,
        department_id: searchParams?.department_id || "",
        month: searchParams?.month || "",
      }
        , { responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'vendor_payment_report.xlsx'); // custom file name
      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (error) {
      console.error('Download failed', error);
    } finally {
      setLoading(false);
    }
  };

  const searchButton = (
    <>
      <Col className="text-right">
        <Button className='ml-1 mt-1' variant="primary" onClick={handleSearch}>
          <i className="bx bx-search-alt"></i> Search
        </Button>
        <Button variant="secondary" className='ml-1' onClick={handleReset}>
          <i className='bx bx-x'></i> {" "} Reset
        </Button>
        {
          (data && data.length > 0) ? (
            <Button className='ml-1 mt-1' variant="success" onClick={handleExport}>
              <i class='bx bx-down-arrow-circle'></i> {" "} Export
            </Button>
          ) : ""
        }
      </Col>

    </>
  );
  return (
    <div className="container">
      <Row>
        <Col xs={12} sm={3} md={4} lg={3} xl={3} className="mb-1"  >
          <Select
            options={financialYears}
            placeholder="Financial Year..."
            onChange={handleYearChange}
            value={selectedYear}
          />
        </Col>
        {isAdmin && (
          <Col xs={12} sm={3} md={4} lg={3} xl={3} className="mb-1"  >
            <Select
              options={departmentList}
              placeholder="Department..."
              onChange={handleDepartmentChange}
              value={departments}
            />
          </Col>
        )}
        <Col xs={12} sm={3} md={4} lg={3} xl={3} className="mb-1"  >
          <Select
            options={SD_FY_MONTHS}
            placeholder="Select Month"
            onChange={handleMonthChange}
            value={selectedMonth}
          />
        </Col>
        {
          !isAdmin ? (
            <>
              {searchButton}
            </>
          ) : ("")
        }
      </Row>
      <Row className='mt-1  mb-2'>
        {
          isAdmin ? (
            <>
              {searchButton}
            </>
          ) : ("")
        }
      </Row>

      {/* <Row>
        <Col className="mb-1 mt-1 text-right"  >
          <Button variant="primary" onClick={handleSearch}>
            <i className="bx bx-search-alt"></i> Search
          </Button>
        </Col>
        

      </Row> */}

      {loading ? (
        <div>Loading...</div>
      ) : (
        <Row className='mb-1 mt-1'>
          <Table striped bordered hover responsive className='smalltable'>
            <thead className="bg-gray-100">
              <tr>
                <th >#</th>
                <th >Vendor Name</th>
                <th >Payment</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, idx) => (
                <tr key={idx}>
                  <td >{idx + 1}</td>
                  <td >{item.vendor_name}</td>
                  <td className="text-right">{S_FORMAT_INR_CURRENCY_AND_AMOUNT(item.vendor_payment || 0)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Row>

      )}
    </div>
  );
}